import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.css'],
  imports: [TranslocoPipe],
})
export class LogOutComponent implements OnInit {
  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this.authService.logout();
  }
}
